module.exports = __webpack_public_path__ + "img/index_list_item_icon_7.beecc4f5.svg";